import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../lib/api";
import { ReelsFeed } from "../components/ReelsFeed";

const Watch = () => {
  const { id } = useParams();
  const [videos, setVideos] = useState(null);
  const [startIndex, setStartIndex] = useState(0);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setVideos(null);
      try {
        const all = (await api.get("/videos?sort=recent")).data;
        let idx = all.findIndex((v) => v.id === id);
        let listed = all;
        if (idx === -1) {
          const single = (await api.get(`/videos/${id}`)).data;
          listed = [single, ...all];
          idx = 0;
        }
        if (!cancelled) { setVideos(listed); setStartIndex(idx); }
      } catch {
        if (!cancelled) setVideos([]);
      }
    })();
    return () => { cancelled = true; };
  }, [id]);

  if (videos === null) {
    return <div className="h-[calc(100vh-6.5rem)] flex items-center justify-center text-zinc-500">Loading…</div>;
  }
  return <ReelsFeed key={id} videos={videos} initialIndex={startIndex} emptyText="Video not found." />;
};

export default Watch;
